/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomerCommentRequestDto } from '../models/CustomerCommentRequestDto';
import type { CustomerTransactionDetailV2Dto } from '../models/CustomerTransactionDetailV2Dto';
import type { CustomerTransactionStatus } from '../models/CustomerTransactionStatus';
import type { CustomerTransactionType } from '../models/CustomerTransactionType';
import type { CustomerTransactionV2Dto } from '../models/CustomerTransactionV2Dto';
import type { TradingType } from '../models/TradingType';
import type { WalletCurrencyV2Dto } from '../models/WalletCurrencyV2Dto';
import type { WalletType } from '../models/WalletType';
import type { CancelablePromise } from '../../../core/CancelablePromise';
import type { BaseHttpRequest } from '../../../core/BaseHttpRequest';
export class WalletV2Service {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param limit
     * @param from
     * @param to
     * @param currency
     * @param currencyType
     * @param accountType
     * @param types
     * @param status
     * @returns CustomerTransactionV2Dto Success
     * @throws ApiError
     */
    public getApiV2WalletTransactions(
        limit?: number,
        from?: string,
        to?: string,
        currency?: string,
        currencyType?: WalletType,
        accountType?: TradingType,
        types?: Array<CustomerTransactionType>,
        status?: CustomerTransactionStatus,
    ): CancelablePromise<Array<CustomerTransactionV2Dto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v2/wallet/transactions',
            query: {
                'limit': limit,
                'from': from,
                'to': to,
                'currency': currency,
                'currencyType': currencyType,
                'accountType': accountType,
                'types': types,
                'status': status,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param id
     * @param type
     * @param currencyType
     * @returns CustomerTransactionDetailV2Dto Success
     * @throws ApiError
     */
    public getApiV2WalletTransactionsDetails(
        id: string,
        type: CustomerTransactionType,
        currencyType?: WalletType,
    ): CancelablePromise<CustomerTransactionDetailV2Dto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v2/wallet/transactions/details',
            query: {
                'id': id,
                'type': type,
                'currencyType': currencyType,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
    }
    /**
     * @param id
     * @param type
     * @param currencyType
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public putApiV2WalletTransactionsComment(
        id: string,
        type: CustomerTransactionType,
        currencyType?: WalletType,
        requestBody?: CustomerCommentRequestDto,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/v2/wallet/transactions/comment',
            query: {
                'id': id,
                'type': type,
                'currencyType': currencyType,
            },
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }
    /**
     * @returns WalletCurrencyV2Dto Success
     * @throws ApiError
     */
    public getApiV2WalletAccounts(): CancelablePromise<Array<WalletCurrencyV2Dto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v2/wallet/accounts',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
